// extracted by mini-css-extract-plugin
module.exports = {"formRecuperar":"style_formRecuperar__1aqle","alertSuccess":"style_alertSuccess__9ATaN"};